import React, { useRef, useEffect } from 'react'
import { SwitchTransition, CSSTransition } from 'react-transition-group'

import styles from './index.module.css'
import { useSelector } from 'react-redux'
import Circular from '../Circular'

const CDN = 'https://7n.bczcdn.com/r/'

export default function ListeningContent() {
  const { stage } = useSelector(state => state.app)
  const { curWord, playingTimer } = useSelector(state => state.test)
  const audioOneRef = useRef(null)
  const currRef = useRef(null)

  useEffect(() => {
    audioOneRef.current.src = CDN + curWord.audio
    /* eslint-disable-next-line */
  }, [stage])

  useEffect(() => {
    audioOneRef.current.src = CDN + curWord.audio
    audioOneRef.current.load()
    currRef.current = audioOneRef.current
  }, [curWord])

  useEffect(() => {
    if (playingTimer && stage <= 1) {
      setTimeout(() => {
        currRef.current.play()
      }, 600)
    } else {
      try {
        currRef.current.currentTime = 0
        currRef.current.pause()
      } catch (error) {
        console.log(error)
      }
    }
  }, [playingTimer, stage])

  return (
    <div className={styles.root}>
      <audio ref={audioOneRef} crossOrigin='anonymous'></audio>
      <SwitchTransition mode='out-in'>
        <CSSTransition key={curWord.word} timeout={250} classNames='trans'>
          <span className={styles.word}>{curWord.word}</span>
        </CSSTransition>
      </SwitchTransition>
      {stage === 1 && <Circular />}
    </div>
  )
}
